import React from 'react';
import styled from 'styled-components';
import { useMatch, useNavigate } from 'react-router-dom';
import { useChurchPlannerRail } from './ChurchPlannerRailContext';
import { plannerColors } from './plannerTheme';
import PlannerTeamAvailabilitySnapshot from './PlannerTeamAvailabilitySnapshot';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {
  FaRegCommentDots as FaRegCommentDotsRaw,
} from 'react-icons/fa';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FaRegCommentDots: any = FaRegCommentDotsRaw;

const Rail = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;

  @media (max-width: 1100px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Widget = styled.div`
  background: ${plannerColors.surface};
  border: 1px solid ${plannerColors.border};
  border-radius: 16px;
  padding: 1.1rem 1.15rem;
  min-height: 420px;
`;

const ActivityList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const ActivityItem = styled.li`
  font-size: 0.8rem;
  color: ${plannerColors.muted};
  line-height: 1.4;
  padding-left: 0.75rem;
  border-left: 2px solid ${plannerColors.border};
`;

const HistoryBtn = styled.button`
  margin-top: 0.75rem;
  width: 100%;
  padding: 0.5rem;
  border-radius: 10px;
  border: 1px solid ${plannerColors.border};
  background: ${plannerColors.surfaceHover};
  color: ${plannerColors.text};
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    border-color: ${plannerColors.accent};
    color: ${plannerColors.accent};
  }
`;

const WidgetTitle = styled.p`
  margin: 0 0 0.75rem;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${plannerColors.muted};
`;

const ActivityHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`;

function SongsCsvWidget() {
  const navigate = useNavigate();

  return (
    <Widget>
      <ActivityHead>
        <WidgetTitle>CSV Import</WidgetTitle>
        <FaRegCommentDots size={16} color={plannerColors.muted} />
      </ActivityHead>
      <ActivityList>
        <ActivityItem>
          Upload a Planning Center CSV and import missing song templates.
        </ActivityItem>
      </ActivityList>
      <HistoryBtn type="button" onClick={() => navigate('/church-planner/songs#songs-csv-import')}>
        Open CSV Import
      </HistoryBtn>
    </Widget>
  );
}

const ChurchPlannerRightRail: React.FC = () => {
  const { dashboardServiceId } = useChurchPlannerRail();
  const dashboardMatch = useMatch('/church-planner/dashboard');
  const serviceDetailsMatch = useMatch('/church-planner/services/:serviceId');
  const songsListMatch = useMatch('/church-planner/songs');
  const serviceId = serviceDetailsMatch?.params.serviceId || (dashboardMatch ? dashboardServiceId : undefined);

  return (
    <Rail>
      {songsListMatch ? <SongsCsvWidget /> : <PlannerTeamAvailabilitySnapshot serviceId={serviceId} />}
    </Rail>
  );
};

export default ChurchPlannerRightRail;
